"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_simple_right_style_1 = __importDefault(require("./uicon.arrow.simple.right.style"));
class UiconArrowSimpleRight extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M24.3887 14.5153L17.8734 8L16.6532 9.22152L22.5631 15.1314H6.86626V16.8575H22.5631L16.6532 22.7674L17.8734 23.9889L24.3887 17.4736C24.7802 17.0809 25 16.549 25 15.9945C25 15.4399 24.7802 14.908 24.3887 14.5153Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconArrowSimpleRight.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconArrowSimpleRight.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_simple_right_style_1.default)(UiconArrowSimpleRight);
//# sourceMappingURL=uicon.arrow.simple.right.js.map